<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
  <app-form-field
    controlId="login-mobile"
    label="REGISTERED MOBILE NUMBER"
    [required]="true"
    [error]="mobileError()"
  >
    <div class="otp-phone-row">
      <app-text-input
        formControlName="mobileNumber"
        controlId="login-mobile"
        type="tel"
        placeholder="10-digit mobile number"
        autocomplete="tel"
        inputMode="tel"
        [maxLength]="16"
        [invalid]="!!mobileError()"
      />

      <button
        type="button"
        class="btn btn-ghost otp-send"
        [disabled]="!canResend()"
        (click)="sendOtp()"
      >
        @if (sending()) {
          <app-spinner [size]="12" label="Sending code" />
        }
        {{ resendLabel() }}
      </button>
    </div>
  </app-form-field>

  @if (notice()) {
    <!--
      Non-committal by contract: RequestOtp answers identically for a
      registered and an unregistered number, so this text must never be
      readable as confirmation that an account exists.
    -->
    <p class="otp-notice" role="status">{{ notice() }}</p>
  }

  @if (codeVisible()) {
    <div class="fg">
      <span class="f" id="otp-group-label">
        ONE-TIME CODE
        <span class="otp-req" aria-hidden="true">*</span>
      </span>

      <!--
        role="group" plus aria-labelledby: six separate inputs are otherwise
        announced as six unrelated single-character fields with no idea what
        they belong to.
      -->
      <div
        class="otp-boxes"
        role="group"
        aria-labelledby="otp-group-label"
        [attr.aria-describedby]="otpError() ? 'login-otp-error' : null"
      >
        @for (digit of digits(); track $index) {
          <input
            #otpBox
            class="otp-box"
            type="text"
            inputmode="numeric"
            autocomplete="one-time-code"
            maxlength="1"
            [value]="digit"
            [class.otp-box-error]="!!otpError()"
            [attr.aria-label]="boxLabel($index)"
            [attr.aria-invalid]="otpError() ? 'true' : null"
            (input)="onDigitInput($event, $index)"
            (keydown)="onDigitKeydown($event, $index)"
            (paste)="onDigitPaste($event, $index)"
          />
        }
      </div>

      @if (otpError()) {
        <p class="otp-err" id="login-otp-error" role="alert">{{ otpError() }}</p>
      } @else if (expiryCountdown() > 0) {
        <p class="otp-hint">Code expires in {{ expiryCountdown() }}s.</p>
      }
    </div>

    <label class="check otp-remember">
      <input type="checkbox" formControlName="rememberMe" />
      Keep me signed in
    </label>
  }

  @if (errorMessage()) {
    <p class="login-inline-error" role="alert">{{ errorMessage() }}</p>
  }

  <button
    class="btn btn-gold btn-block"
    type="submit"
    [disabled]="verifying() || sending() || (codeVisible() && expired())"
  >
    @if (verifying()) {
      <app-spinner [size]="13" label="Signing in" />
      Signing in
    } @else {
      Sign in
    }
  </button>
</form>
